
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-10a84800!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CompanyNoticeDetail.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/company-notice-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-10a84800!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/company-notice-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyNoticeDetail.vue
// module id = 609
// module chunks = 1